/**
 * Canonical public review-gate URL for dashboard View Page / copy link.
 * Uses showmyrep.io so unique_id resolution is not affected by legacy u.reviewour.biz IDs.
 */
export function reviewGatePublicBaseUrl() {
  const isStaging = typeof window !== 'undefined' && window.location.origin.includes('staging.');
  return isStaging ? 'https://staging.replyengine.io/r/' : 'https://app.showmyrep.io/r/';
}

export function reviewGatePublicUrl(uniqueId) {
  return `${reviewGatePublicBaseUrl()}${uniqueId || ''}`;
}
